import { render, staticRenderFns } from "./ClassifiedManage.vue?vue&type=template&id=3a0e58c4&scoped=true&"
import script from "./ClassifiedManage.vue?vue&type=script&lang=js&"
export * from "./ClassifiedManage.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedManage.vue?vue&type=style&index=0&id=3a0e58c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0e58c4",
  null
  
)

export default component.exports